<template>
  <div class="fff-background">
    <!-- 轮播图 -->
    <section id="carousel" class="d-flex align-items-center">
      <div class="testimonials-slider swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in bannerList" :key="'banner' + index">
            <picture>
              <source media="(max-width: 768px)" :srcset="item.mdSrc" />
              <source media="(min-width: 768px)" :srcset="item.lgSrc" />
              <img :src="item.lgSrc" class="image-width-100" />
            </picture>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </section>
    <!-- 案例展示 -->
    <section id="case" class="pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <div class="text-align-center">
          <h1 class="title-main font-weight-bold pb-2">案例展示</h1>
          <p class="title-sub pb-3">Case Show</p>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-4 md-hidden" v-for="(item, index) in caseList" :key="'case' + index">
            <div class="mask-box" @click="casePath(item.path)">
              <img :src="item.src" class="case-image" /><br />
              <div class="mask">
                <span class="title-sub mask-title">查看详情>></span>
              </div>
            </div>
            <span class="title-name font-weight-bold display-inline-block pt-3 indentation">{{ item.name }}</span
            ><br />
            <span class="title-desc display-inline-block pt-2 pb-3 indentation text-line-height-2">{{ item.describe }}</span>
          </div>
          <div class="col-12 lg-hidden" v-for="(item, index) in caseList" :key="'case' + index">
            <div class="line">
              <span class="title-name font-weight-bold display-inline-block pt-3 indentation">{{ item.name }}</span
              ><br />
              <span class="title-desc display-inline-block pt-2 pb-3 indentation text-line-height-2">{{ item.describe }}</span>
              <div class="mask-box" @click="casePath(item.path)">
                <img :src="item.src" class="case-image" /><br />
                <div class="mask">
                  <span class="title-sub mask-title">查看详情>></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 需求 -->
    <section id="need" class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <div class="text-align-center">
          <h1 class="title-main font-weight-bold pb-2">从极速设计到可视化开发</h1>
          <p class="title-sub pb-3">引导和满足客户需求,帮助企业轻松完成多端系统建设</p>
        </div>
        <div class="row">
          <div class="col">
            <picture>
              <source media="(max-width: 768px)" srcset="@/assets/img/md/home/design.png" />
              <source media="(min-width: 768px)" srcset="@/assets/img/lg/home/design.png" />
              <img src="@/assets/img/lg/home/design.png" class="image-width-100" />
            </picture>
          </div>
        </div>
        <div class="row">
          <div class="col md-hidden">
            <img src="@/assets/img/lg/home/flowPath.png" class="image-width-100" />
          </div>
        </div>
      </div>
    </section>

    <!-- 合作 -->
    <section id="cooperation" class="pt-4 pb-4" data-aos="fade-up">
      <h1 class="title-main font-weight-bold text-align-center pb-3">携手共赢，让合作伙伴的投资更长远更有价值</h1>
      <picture>
        <source media="(max-width: 768px)" srcset="@/assets/img/md/home/partner.png" />
        <source media="(min-width: 768px)" srcset="@/assets/img/lg/home/partner.png" />
        <img src="@/assets/img/lg/home/partner.png" class="image-width-100" />
      </picture>
    </section>
  </div>
</template>

<script>
import Purecounter from '@srexi/purecounterjs'
import Swiper from 'swiper/swiper-bundle.min.js'
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      oneWidth: '100%',
      intersectionOptions: {
        root: document.querySelector('.skills-content'),
        rootMargin: '0px 0px 0px 0px',
        threshold: [0.25, 0.75], // [0.25, 0.75] if you want a 25% offset!
      },
      // 轮播图
      bannerList: [
        {
          lgSrc: require('@/assets/img/lg/carousel/carousel1.png'),
          mdSrc: require('@/assets/img/md/carousel/carousel1.png'),
        },
        {
          lgSrc: require('@/assets/img/lg/carousel/carousel2.png'),
          mdSrc: require('@/assets/img/md/carousel/carousel2.png'),
        },
      ],
      // 案例选择
      caseList: [
        {
          src: require('@/assets/img/common/case/case1.png'),
          name: '光模块云编码器',
          describe: '客户在全球范围内为客户提供创新的光学技术，以实现高效互联的世界',
          path: '/case/opticalModule',
        },
        {
          src: require('@/assets/img/common/case/case2.png'),
          name: '某宇海图系统',
          describe: '是一款监控海上船只的系统,通过雷达,光电,AIS扫描船只,为海上执法提供依据',
          path: '/case/hlx',
        },
        {
          src: require('@/assets/img/common/case/case3.png'),
          name: '某克设备维修保养',
          describe: '搭建生产设备报修体系,以工单任务的形式加强设备维修工作的及时性和有效性',
          path: '/case/equipmentRepair',
        },
        {
          src: require('@/assets/img/common/case/case4.png'),
          name: '订单管理系统',
          describe: '是为客户提供一整套销售下单,物流追踪的信息平台,解决订单信息准确性,及时性,可靠性',
          path: '/case/orderManage',
        },
        {
          src: require('@/assets/img/common/case/case5.png'),
          name: '某安企业管理App',
          describe: '企业管理App在新冠肺炎疫情形式下监测复工人员抗原和核酸情况',
          path: '/case/secure',
        },
        {
          src: require('@/assets/img/common/case/case6.png'),
          name: '职业健康管理系统',
          describe: '职业健康管理体系的目的是提升工作场所的健康性和安全性，维护员工的合法利益，保护环境',
          path: '/case/ehs',
        },
        {
          src: require('@/assets/img/common/case/case7.png'),
          name: '电磁车载巡检系统',
          describe: '十亿级巡测数据的自动化清洗、解析、汇总展示，为省生态环境厅开展的区域电磁环境质量监测与评估试点工作提供数据支撑',
          path: '/case/electromagneticVehicle',
        },
        {
          src: require('@/assets/img/common/case/case8.png'),
          name: '生物安全云平台及小程序',
          describe: '通过云平台端、小程序端的两个业务入口实现企业对其下级分公司、养殖场地的分层式管理和移动化办公需要',
          path: '/case/muBang',
        },
        {
          src: require('@/assets/img/common/case/case9.png'),
          name: '用户统一平台',
          describe: '控制用户访问实现用户身份认证，通过单点登录提高用户体验',
          path: '/case/platForm',
        },
      ],
    }
  },
  created() {},
  //生命周期 - 挂载完成（可以访问 DOM 元素）
  mounted() {
    new Swiper('.testimonials-slider', {
      speed: 600,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    })
    const glightbox = this.$GLightbox({
      autoplayVideos: true,
    })
    glightbox.on('open', () => {})

    const pure = new Purecounter()

    let maodian = this.GetQueryString('maodian') //进入页面，如果带有锚点参数，则跳转至锚点地方，参数值就是id
    if (maodian) {
      this.goAnchor('#' + maodian)
    }
  },
  methods: {
    onWaypoint({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        let progress = this.select('.progress .progress-bar', true)
        progress.forEach((el) => {
          el.style.width = el.getAttribute('aria-valuenow') + '%'
        })
      }
      // if (direction === this.$waypointMap.DIRECTION_TOP) {
      //     console.log('waypoint going top!')
      // }
    },
    select(el, all) {
      el = el.trim()
      if (all) {
        return [...document.querySelectorAll(el)]
      } else {
        return document.querySelector(el)
      }
    },
    // 案例展示选择跳转路由
    casePath (path) {
      this.$store.dispatch('setMainMenu', '/case')
      this.$store.dispatch('setSubMenu', path)
      this.$router.push({ path: path })
    },
    goAnchor(selector) {
      var anchor = document.querySelector(selector) //获取元素
      if (anchor) {
        this.$nextTick(() => {
          document.body.scrollTop = this.$el.querySelector(selector).scrollIntoView()
        })
      }
    },
    //获取参数
    GetQueryString(name) {
      var href = window.location.href
      var r = this.getSearchString(name, href)
      if (r != null) return decodeURI(r)
      return null
    },
    getSearchString(key, Url) {
      var str = Url
      str = str.substring(1, str.length)
      if (str.indexOf('?') != -1) {
        var arr = str.split('?')[1].split('&') // 获取？后的参数内容，并以&分隔字符串，获得类似name=xiaoli这样的元素数组
        var obj = new Object()
        // 将每一个数组元素以=分隔并赋给obj对象
        for (var i = 0; i < arr.length; i++) {
          var tmp_arr = arr[i].split('=')
          obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1])
        }
        return obj[key]
      }
    },
  },
}
</script>

<style scoped>
.case-image {
  width: 90%;
  margin: 0 5%;
}
.case-image:hover {
  /* background-color: red; */
  box-shadow: 0px 0.0625rem 0.625rem rgba(73, 73, 73, 0.25);
}
.mask-box {
  position: relative;
  cursor: pointer;
}
.mask-box:hover .mask {
  opacity: 1;
}
.mask {
  position: absolute;
  top: 0;
  left: 5%;
  width: 90%;
  height: 100%;
  background-color: rgba(101, 101, 101, 0.5);
  color: #fff;
  opacity: 0;
}
.mask-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.lg-hidden .line {
  border-top: 1px solid #ccc;
}
@media (max-width: 768px) {
  .mask-box {
    margin-bottom: 1rem;
  }
}
</style>
